// extracted by mini-css-extract-plugin
export default {"page":"Dashboard_page__apQ4e","card":"Dashboard_card__tz6cl","title":"Dashboard_title__Fh+Zm","subtitle":"Dashboard_subtitle__mfKbW","actions":"Dashboard_actions__9pfl0"};